import { Flex, Text, Icon } from '@chakra-ui/react';
import { RiCheckboxIndeterminateFill } from 'react-icons/ri';
import { removeSelectedSkill } from '../utils';

const SkillPhone = ({ props, qObj, skill, style, skillCounter }) => {
  return (
    <Flex sx={{ ...style.skillsBox.phoneBox.flexItem }}>
      <Text key={skillCounter} sx={{ ...style.skillsBox.phoneBox.itemText }}>
        {skill}
      </Text>
      <Icon
        onClick={() => removeSelectedSkill(props, qObj.qid, skill)}
        as={RiCheckboxIndeterminateFill}
        sx={{ ...style.skillsBox.phoneBox.icon }}
      />
    </Flex>
  );
};
export default SkillPhone;
